import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=bd169e56&scoped=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=bd169e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd169e56",
  null
  
)

export default component.exports